"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAnalysisPerformance = void 0;
const react_1 = require("react");
const react_query_1 = require("react-query");
const elements_core_rest_transport_1 = require("@hydrogen/elements.core.rest.transport");
const elements_data_wealth_app_use_contact_id_1 = require("@hydrogen/elements.data.wealth.app.use-contact-id");
const elements_data_wealth_app_use_investment_id_1 = require("@hydrogen/elements.data.wealth.app.use-investment-id");
const elements_core_event_bus_1 = require("@hydrogen/elements.core.event-bus");
const elements_data_wealth_rest_use_benchmark_portfolio_1 = require("@hydrogen/elements.data.wealth.rest.use-benchmark-portfolio");
function useAnalysisPerformance({ payload, }) {
    const contactId = (0, elements_data_wealth_app_use_contact_id_1.useContactId)();
    const investmentId = (0, elements_data_wealth_app_use_investment_id_1.useInvestmentId)();
    const query = (0, react_query_1.useQuery)(['analysis-performance', contactId, investmentId, payload], () => (0, elements_core_rest_transport_1.customApi)()
        .post(`/v1.0/widgets/clients/${contactId}/investments/${investmentId}/analysis/performance?language=de`, payload)
        .then(({ data }) => data), {
        keepPreviousData: true,
        enabled: !!contactId && !!investmentId,
        refetchOnMount: 'always',
    });
    (0, react_1.useEffect)(() => {
        const unsubscriber = (0, elements_core_event_bus_1.subscribe)(elements_data_wealth_rest_use_benchmark_portfolio_1.BENCHMARK_PORTFOLIO_TOPIC, query.refetch);
        return () => {
            unsubscriber();
        };
    }, []);
    return Object.assign(Object.assign({}, query), { isLoading: query.isIdle || query.isLoading });
}
exports.useAnalysisPerformance = useAnalysisPerformance;
//# sourceMappingURL=use-analysis-performance.js.map